/**
 * name 热点详情
 * author zhang.yingyu
 * createTime 2019-04-02
 */
"use strict";
angular.module("hotPointDetailModule", [])
    .controller("hotPointDetailCtrl", ['$scope','$q','$state', '$modalInstance','transData', '$filter',
        function($scope, $q, $state, $modalInstance,transData, $filter) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    detailList:transData.detailDatas,
                };
            }
            /**
             * [getSplitData description] 将字符串按;分割
             */
            $scope.getSplitData=function(value){
                var arr=[];
                if(!!value){
                    arr=value.split(";");
                }
                return arr;
            };
            /**
             * [getHotPointTime description] 获取热点时间
             */
            $scope.getHotPointTime=function(time){
                if(!!time){
                    return $filter('date')(new Date(time), 'MM-dd HH:mm:ss');
                }
            };
            /**
             * [initData description]
             * @return {[type]} [description]
             */
            function initData() {}
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function () {
                $modalInstance.close('fail');
            };
    }]);